module.exports = __webpack_public_path__ + "static/media/om.9170bae1.svg";